<script setup>
  import ComponentIcon from "@components/Icons/Icon.vue";
  import MergeAccountIconGroup from "@pages/MergeAccount/Components/IconGroup.vue";
  import MergeAccountStep from "@pages/MergeAccount/Components/Step.vue";
  import MergeAccountSteps from "@pages/MergeAccount/Components/Steps.vue";

  defineOptions({
    name: "MergeAccountCreateSteps",
  });
</script>

<template>
  <MergeAccountSteps>
    <MergeAccountStep>
      <MergeAccountIconGroup class="min-h-32">
        <ComponentIcon class="shrink-0" custom="front-desk" />
        <ComponentIcon class="text-4xl">autorenew</ComponentIcon>
        <ComponentIcon class="shrink-0" custom="laptop" />
      </MergeAccountIconGroup>

      <div>
        <h3 class="text-xl font-semibold">1. Verknüpfung starten</h3>
        <p class="mt-4">
          Die Verknüpfung wird vorbereitet und Sie werden zu Ihrem zweiten Account weitergeleitet, um sich dort
          einzuloggen.
        </p>
      </div>
    </MergeAccountStep>

    <MergeAccountStep>
      <MergeAccountIconGroup class="min-h-32">
        <div class="flex flex-col items-center space-y-1">
          <ComponentIcon class="shrink-0" custom="front-desk" />
          <ComponentIcon class="text-3xl">lock_open</ComponentIcon>
        </div>

        <div class="flex flex-col items-center space-y-1">
          <ComponentIcon class="shrink-0" custom="laptop" />
          <ComponentIcon class="text-3xl">lock_open</ComponentIcon>
        </div>
      </MergeAccountIconGroup>

      <div>
        <h3 class="text-xl font-semibold">2. Accounts entsperren</h3>
        <p class="mt-4">
          Um die Verknüpfung durchzuführen, benötigen Sie nach dem Login die
          <span class="font-semibold">Datenschutzwörter beider Accounts.</span>
        </p>
      </div>
    </MergeAccountStep>

    <MergeAccountStep>
      <MergeAccountIconGroup class="min-h-32">
        <ComponentIcon class="shrink-0" custom="front-desk" />
        <ComponentIcon class="text-4xl">published_with_changes</ComponentIcon>
        <ComponentIcon class="shrink-0" custom="laptop" />
      </MergeAccountIconGroup>

      <div>
        <h3 class="text-xl font-semibold">3. Accounts verknüpft</h3>
        <p class="mt-4">
          Nach erfolgreicher Verknüpfung haben Sie eine gemeinsame Patientenübersicht. Der Zugriff erfolgt zukünftig
          über das Datenschutzpasswort Ihrer Warenwirtschaft, egal von wo aus Sie sich einloggen.
        </p>
      </div>
    </MergeAccountStep>
  </MergeAccountSteps>
</template>
